import { FaCheck, FaTimes, FaHandPointRight } from 'react-icons/fa';
import { useOutletContext } from 'react-router-dom';

const PRIMARY_BLUE = '#0056d2'; 

export default function Pricing() {
    const { openDemoModal } = useOutletContext(); // Access modal function

    const pricingPlans = [
        {
            name: 'Standard',
            price: '$49',
            description: 'Best for new or small academies with basic management needs.',
            features: [
                { text: 'Up to 50 Active Students', available: true },
                { text: 'Basic Batch Scheduling', available: true },
                { text: 'Parent Portal Access', available: true },
                { text: 'Automated Invoicing', available: true },
                { text: 'Performance Analytics', available: false },
                { text: 'Multi-Branch Support', available: false },
            ],
            isPopular: false,
        },
        {
            name: 'Professional',
            price: '$99',
            description: 'Ideal for growing academies needing robust management and reporting.',
            features: [
                { text: 'Up to 250 Active Students', available: true },
                { text: 'Advanced Scheduling & Rostering', available: true },
                { text: 'Parent Portal Access', available: true },
                { text: 'Automated Invoicing & Reminders', available: true },
                { text: 'Performance Analytics Dashboard', available: true },
                { text: 'Multi-Branch Support', available: false },
            ],
            isPopular: true,
        },
        {
            name: 'Enterprise',
            price: 'Custom',
            description: 'Perfect for large academy chains and institutions requiring full scalability.',
            features: [
                { text: 'Unlimited Students', available: true },
                { text: 'Custom API Integrations', available: true },
                { text: 'Dedicated Account Manager', available: true },
                { text: 'Advanced Financial Reporting', available: true },
                { text: 'Full Analytics Suite', available: true },
                { text: 'Multi-Branch Support', available: true },
            ],
            isPopular: false,
        },
    ];

    return (
        <div className="bg-light py-5">
            <div className="container py-lg-5">
                
                {/* Header */}
                <header className="text-center mb-5">
                    <h1 className="display-5 fw-bold text-dark mb-3">Simple Pricing, <span style={{ color: PRIMARY_BLUE }}>Powerful Results</span></h1>
                    <p className="lead text-secondary mx-auto" style={{ maxWidth: '800px' }}>
                        No hidden fees. Choose the plan that fits your academy's scale, or contact us for an Enterprise solution.
                    </p>
                </header>

                {/* Pricing Cards */}
                <div className="row justify-content-center g-4">
                    {pricingPlans.map((plan, index) => (
                        <div key={index} className="col-lg-4 col-md-6">
                            <div 
                                className={`card rounded-4 h-100 shadow ${plan.isPopular ? 'border-primary border-3' : 'border-0'}`}
                            >
                                <div className="card-body p-4 p-md-5 d-flex flex-column">
                                    {plan.isPopular && (
                                        <span className="badge bg-primary text-white rounded-pill mb-2 align-self-center">Most Popular</span>
                                    )}
                                    <h2 className="card-title text-center fw-bold text-dark mb-1">{plan.name}</h2>
                                    <p className="text-center text-muted small mb-4">{plan.description}</p>
                                    
                                    <div className="text-center mb-4">
                                        <span className="display-4 fw-bold" style={{ color: PRIMARY_BLUE }}>
                                            {plan.price === 'Custom' ? plan.price : plan.price.split('$')[1]}
                                        </span>
                                        {plan.price !== 'Custom' && <span className="text-muted">/month</span>}
                                    </div>
                                    
                                    <ul className="list-unstyled flex-grow-1">
                                        {plan.features.map((feature, idx) => (
                                            <li key={idx} className="d-flex align-items-center mb-2 small">
                                                {feature.available ? (
                                                    <FaCheck className="text-success me-2" />
                                                ) : (
                                                    <FaTimes className="text-muted me-2" />
                                                )}
                                                <span className={feature.available ? 'text-dark' : 'text-muted'}>
                                                    {feature.text}
                                                </span>
                                            </li>
                                        ))}
                                    </ul>
                                    
                                    {/* Action Button */}
                                    <div className="mt-4">
                                        <button
                                            className="btn text-white fw-bold w-100 py-2"
                                            style={{ 
                                                background: plan.price === 'Custom' ? PRIMARY_BLUE : '#495057', 
                                                border: 'none', 
                                                borderRadius: '5px',
                                                boxShadow: plan.price === 'Custom' ? '0 4px 10px rgba(0, 86, 210, 0.3)' : 'none',
                                            }}
                                            onClick={openDemoModal}
                                            disabled={plan.price !== 'Custom' && plan.isPopular}
                                        >
                                            {plan.price === 'Custom' ? (
                                                <>
                                                    <FaHandPointRight className="me-2" /> Talk to Sales
                                                </>
                                            ) : (
                                                'Start 14-Day Free Trial'
                                            )}
                                        </button>
                                        <p className="text-center small text-muted mt-2 mb-0">
                                            {plan.price === 'Custom' ? 'Get a detailed quote based on scale.' : 'Free trial available for 14 days.'}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </div>
    );
}